import React, {useState, useEffect} from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Tmdb from '../../lib/Tmdb';
import Autoembed from '../../lib/Autoembed';
import {Grid, Button, Box, Tab, Tabs, Skeleton} from '@mui/material';
import FeaturedItem from '../../components/FeaturedItem/FeaturedItem';
import Seasons from '../../components/FeaturedItem/Seasons';
import { styled } from "@mui/material/styles";
import Iframe from '../../components/Iframe/Iframe';

var oldWindowOpen = window.open;
window.open = function (url, name, features, replace) {
  console.log("errou")
 // myIframe.src = url;
  // if you want to use functionality of original window.open call the oldWindowOpen function
  oldWindowOpen(url, 'myName', 'myFeatures');
}

const FullDescription = () => {
    const [selectedMovieItem, setSelectedMovieItem] = useState(null);
    const [seasonFilter, setSeasonFilter] = useState('');
    const [tabValue, setTabValue] = useState(0);

    let { type, id } = useParams();

    const [iframe, setIframe] = useState({show:false});

    const handleIframe =  (value) =>{
        setIframe(value)
        value.show == true? (window.scrollTo(0, 20)) : (window.scrollTo(0, document.body.scrollHeight));
        
    }
    const handleSeasonChange = (tabNum, seasonValue) => {
        setSeasonFilter (seasonValue)
        setTabValue(tabNum);
      };
    useEffect(()=>{
        const loadItem = async () =>{
            let item = await Tmdb.getAditionalInfo(id, type);
            setSelectedMovieItem(item)
            setSeasonFilter(item.seasons[0].name)
         }
         loadItem();
      
      },[]);
      return(
        <> 
        {selectedMovieItem == null? 
        <div style={{height:"85vh",width:"100%", display:"grid", flexWrap:"wrap", alignContent:"center",}}>
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"8px", marginLeft:"3rem" }} variant="rect" width={'60%'} height={'3.75rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"4%" }} variant="rect" width={'35%'} height={'1.2rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"8px", marginLeft:"3rem", marginTop:"1rem" }} variant="rect" width={'45%'} height={'6rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"1rem" }} variant="rect" width={'25%'} height={'1.2rem'} />
      </div>
        :
        <>
        <FeaturedItem item={selectedMovieItem} currentView={"fullDescription"}/>
        {type == 'tv'?
            <div style={{marginTop:"-3rem", minHeight:"60vh"}}>
             <Box sx={{ maxWidth: '100%', bgcolor: 'background.paper', marginLeft:"3%", marginRight:"3%" }}>
                <Tabs TabIndicatorProps={{style: {backgroundColor: "#d32f2f"}}} value={tabValue} variant="scrollable" scrollButtons="auto"  aria-label="scrollable auto tabs example">
                    {selectedMovieItem.seasons.map((item,key)=>(
                        <Tab label={item.name} onClick={() => handleSeasonChange(key, item.name)} key={key}/>
                    ))}
                </Tabs>
            </Box>
            {selectedMovieItem.seasons.map((item,key)=>(
                seasonFilter == item.name  ?
                    <Seasons key={key} item={item} serieId={id} handleIframe={handleIframe}/>
                    :
                    <div key={key}></div>
            ))}
            </div>
        :
        <>        
        {iframe.show == false?<div style={{paddingBottom:"7vh"}}><Button variant="contained" size="large" color="error" style={{marginLeft:"3%",}}  onClick={() => handleIframe({show:true,movieId:id,type:'movie'})}>Ver Filme</Button></div>:<></>} 
        </>
        }
        <Iframe handleIframe={handleIframe} iframe={iframe}/>

        </>
        }
        </>
    );
}
export default FullDescription
